import type { AutomaticNotifications } from 'ab-requestModels/notificationSettings.requestModel';

import type { AutoNotifyOption } from '@acceligentllc/shared/enums/autoNotifyOption';

export class AutomaticNotificationsFM {
	notifyOnPublish: Nullable<AutoNotifyOption>;
	notifyOnCancel: Nullable<AutoNotifyOption>;
	notifyOnPause: boolean;
	notifyOnResume: boolean;
	notifyUnassignedEmployees: boolean;
	notifyMultipleAssignments: boolean;
	notifySupervisors: boolean;
	notifyOnReportReject: boolean;
	notifyOnTimeSheetReject: boolean;
	enableScheduledNotifications: boolean;

	// Only on FE to evaluate checkbox
	enableAutoNotifyOnPublish?: boolean;
	enableAutoNotifyOnCancel?: boolean;

	enableNotifyQAQC: boolean;
	enableNotifyDeliverableAssignee: boolean;
	enableAutoNotifyDailyTips: boolean;

	static fromForm(form: AutomaticNotificationsFM): AutomaticNotifications {
		return {
			notifyOnPublish: form.enableAutoNotifyOnPublish ? form.notifyOnPublish : null,
			notifyOnCancel: form.enableAutoNotifyOnCancel ? form.notifyOnCancel : null,
			notifyOnPause: form.notifyOnPause,
			notifyOnResume: form.notifyOnResume,
			notifyUnassignedEmployees: form.notifyUnassignedEmployees,
			notifyMultipleAssignments: form.notifyMultipleAssignments,
			notifySupervisors: form.notifySupervisors,
			enableNotifyQAQC: form.enableNotifyQAQC,
			enableNotifyDeliverableAssignee: form.enableNotifyDeliverableAssignee,
			enableAutoNotifyDailyTips: form.enableAutoNotifyDailyTips,
			notifyOnReportReject: form.notifyOnReportReject,
			notifyOnTimeSheetReject: form.notifyOnTimeSheetReject,
			enableScheduledNotifications: form.enableScheduledNotifications,
		};
	}
}
